'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.init = undefined;

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _dom = require('../common/dom.js');

var _dom2 = _interopRequireDefault(_dom);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var init = exports.init = function init() {
  HeaderScroll();
  bindUIActions();
};

var HeaderScroll = function HeaderScroll() {
  var headerOffset = (0, _jquery2.default)(_dom2.default.headerMarker).offset().top;
  if ((0, _jquery2.default)(window).scrollTop() > headerOffset) {
    if (!(0, _jquery2.default)(_dom2.default.header).hasClass('is-sticky')) {
      (0, _jquery2.default)(_dom2.default.header).addClass('is-sticky');
      (0, _jquery2.default)(_dom2.default.inlineCart).addClass('is-sticky');
    }
  } else {
    if ((0, _jquery2.default)(_dom2.default.header).hasClass('is-sticky')) {
      (0, _jquery2.default)(_dom2.default.header).removeClass('is-sticky');
      (0, _jquery2.default)(_dom2.default.inlineCart).removeClass('is-sticky');
    }
  }
};

var bindUIActions = function bindUIActions() {
  (0, _jquery2.default)(window).on('resize', function () {
    HeaderScroll();
  });
  (0, _jquery2.default)(window).on('scroll', function () {
    HeaderScroll();
  });
};